// Weitere Firma anlegen (/rechnung/firma-neu); Inhalt in seiten/FirmaNeu.tsx (erst bei Bedarf geladen)
import { faul } from './faul';

export const FirmaNeuSeite = faul(() => import('./seiten/FirmaNeu'));
